export const capitalizeBrandName = (brandName) => {
  brandName = brandName.toLowerCase()
  return brandName.charAt(0).toUpperCase() + brandName.slice(1)
}
